import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ClientAssessment from './pages/client-assessment';
import NotFoundPage from './pages/not-found';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/client-assessment" element={<ClientAssessment />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
